
import { request, METHOD } from '../utils/request.js'

// 查看总分
export function scoreStaBySnCode (obj) {
    return request(
      '/h5Mfitness/com/scoreStaBySnCode',
      METHOD.POST,
      obj
    )
  }
  // 查看个人报告
  export function finalScoreList (obj) {
    return request(
      '/h5Mfitness/com/finalScoreList',
      METHOD.POST,
      obj
    )
  }
  
  // 体锻记录
  export function getWgzTest(obj) {
    return request(
      '/h5Mfitness/parent/getWgzTest',
      METHOD.POST,
      obj
    )
  }
  // 体锻数据
  export function getWgzData(obj) {
    return request(
      '/h5Mfitness/parent/getWgzData',
      METHOD.POST,
      obj
    )
  }
    // 按照锻炼次数计算排名百分比

    export function getTopByCount(obj) {
      return request(
        '/h5Mfitness/parent/getTopByCount',
        METHOD.POST,
        obj
      )
    }
  
 